import "./FeatureConfig.scss";
import axios from "axios";
const env = require(`@/environments/${process.env.VUE_APP_ENV_PATH}`);
import { getTokenHeader } from "@/helpers/commonHelper";
import EditFeature from "@/components/POI/EditFeature/EditFeature.vue";
import GlobalFeatureConfig from "@/components/POI/GlobalFeatureConfig/GlobalFeatureConfig.vue";
import { getGlobalFeatureGroups } from "@/helpers/featureGroupHelper.js";

export default {
  data: () => ({
    showFeatureInput: false,
    snackbarText: "",
    snackbarColor: "",
    snackbar: false,
    isLoadingData: true
  }),
  async mounted() {
    await this.getData();
  },
  methods: {
    getGlobalFeatureGroups,

    createError(ex) {
      this.snackbarText =
        "Es ist ein Fehler aufgetreten. Bitte versuchen Sie es später noch einmal";
      this.snackbarColor = "#c55c52";
      this.snackbar = true;
      console.error(ex);
    },
    createSuccess(message) {
      this.snackbarText = message;
      this.snackbarColor = "#00636C";
      this.snackbar = true;
    },
    async updateGroup(args) {
      let { group, successText, refreshGroups = true } = args;
      if (group.title) {
        const headers = getTokenHeader();
        try {
          const res = await axios.put(
            `${env.poi_api_client_url}featureGroup/${group._id}`,
            group,
            { headers }
          );
          if (res.status === 200) {
            this.createSuccess(successText);
            if (refreshGroups)
              await this.$store.dispatch("getGlobalFeatureGroups");
            this.selectedGroup = {};
            group = {};
          }
        } catch (ex) {
          this.createError(ex);
        }
      }
    },

    async createGroup(args) {
      let {
        global,
        createInputValue,
        createInputGroups,
        createInputTypes
      } = args;
      if (createInputValue) {
        const headers = getTokenHeader(),
          postData = {
            title: createInputValue,
            categoryGroups: createInputGroups,
            categoryTypes: createInputTypes
          };

        if (!global) postData.owner = this.selectedPrincipal.id;

        try {
          const res = await axios.post(
            `${env.poi_api_client_url}featureGroup/`,
            postData,
            { headers }
          );
          if (res.status === 200 || res.status === 201) {
            this.createSuccess("Gruppe wurde erfolgreich erstellt");
            createInputValue = "";
            this.createInputValid = true;
            await this.$store.dispatch("getGlobalFeatureGroups");
          } else this.createError();
        } catch (ex) {
          this.createError(ex);
        }
      }
    },
    async getData() {
      this.isLoadingData = true;
      try {
        await this.$store.dispatch("getGlobalFeatureGroups");
        await this.$store.dispatch("getGlobalConfig");
      } catch (ex) {
        this.createError(ex);
      } finally {
        this.isLoadingData = false;
      }
    }
  },
  computed: {
    currentUser() {
      return this.$store.state.currentUser;
    },
    isPoiAdmin() {
      return this.currentUser?.scopes?.includes("role:poi_admin");
    },
    featureGroups() {
      return this.$store.state.globalFeatureGroups;
    },
    selectedPrincipal() {
      return this.$store.state.selectedPrincipal;
    },
    ownFeatureGroups() {
      return (
        this.featureGroups.filter(
          featureGroup => featureGroup.owner === this.selectedPrincipal.id
        ) || []
      );
    },
    selectedFeatureGroups: {
      get() {
        return this.getGlobalFeatureGroups(true);
      },
      async set(newVal) {
        const oldVal = this.selectedFeatureGroups,
          changedValues = [],
          globalGroups = this.getGlobalFeatureGroups(null);

        if (newVal.length > oldVal.length)
          newVal.forEach(val => {
            if (!oldVal.find(ov => ov._id === val)) {
              const changedVal = globalGroups?.find(group => group._id === val);
              changedVal.principals.push(this.selectedPrincipal.id);

              changedValues.push(changedVal);
            }
          });
        else
          oldVal.forEach(val => {
            if (!newVal.find(nv => nv === val._id)) {
              val.principals.remove(this.selectedPrincipal.id);
              changedValues.push(val);
            }
          });

        await changedValues.asyncForEach(async val => {
          await this.updateGroup({
            group: val,
            successText: "Erfolgreich gespeichert",
            refreshGroups: false
          });
        });

        if (changedValues.length)
          await this.$store.dispatch("getGlobalFeatureGroups");
      }
    },
    globalFeatureGroups() {
      return this.getGlobalFeatureGroups(null);
    },
    config() {
      return this.$store.state.globalConfig;
    },
    availableFavoriteFeatures() {
      const subscribedGroups = this.getGlobalFeatureGroups(true) || [];
      const ownGroups = this.ownFeatureGroups || [];
      const allGroups = [...subscribedGroups, ...ownGroups];
      return allGroups.map(group => group.features).flat();
    },
    selectedFavoriteFeatures: {
      get() {
        return this.config?.favoriteFeatures ?? [];
      },
      async set(newVal) {
        this.config.favoriteFeatures = newVal;
        try {
          const headers = getTokenHeader();
          await axios.put(
            `${env.poi_api_client_url}config/${this.selectedPrincipal?.id}/`,
            this.config,
            { headers }
          );
          this.createSuccess("Erfolgreich gespeichert");
        } catch (ex) {
          this.createError(ex);
        }
      }
    }
  },
  watch: {
    async selectedPrincipal() {
      await this.getData();
    }
  },
  components: { EditFeature, GlobalFeatureConfig }
};
